const IMG_BASE = "https://image.tmdb.org/t/p/w500"

export default function MovieCard({ movie, onClick, isActive }) {
  const poster = movie.poster_path
    ? `${IMG_BASE}${movie.poster_path}`
    : null

  return (
    <div
      onClick={() => onClick(movie)}
      className={`relative flex-shrink-0 w-48 cursor-pointer rounded-lg overflow-hidden transition-all duration-200
        ${isActive ? "ring-2 ring-yellow-400" : "hover:ring-2 hover:ring-white"}`}
    >
      <div className="aspect-[2/3] bg-zinc-800">
        {poster ? (
          <img
            src={poster}
            alt={movie.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-500 text-xs text-center px-2">
            {movie.title}
          </div>
        )}
      </div>
      {isActive && (
        <div className="absolute inset-0 bg-yellow-400/10" />
      )}
    </div>
  )
}
